import _classCallCheck from '../../../../../@babel/runtime/helpers/esm/classCallCheck.js';
import _createClass from '../../../../../@babel/runtime/helpers/esm/createClass.js';
import _get from '../../../../../@babel/runtime/helpers/esm/get.js';
import _inherits from '../../../../../@babel/runtime/helpers/esm/inherits.js';
import _possibleConstructorReturn from '../../../../../@babel/runtime/helpers/esm/possibleConstructorReturn.js';
import _getPrototypeOf from '../../../../../@babel/runtime/helpers/esm/getPrototypeOf.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Apply functionality that simplifies the process of defining a custom element
 * with a namespace. Namespacing a custom element is required for multiple
 * versions of the element to exist within the same page because the
 * CustomElementRegistry does not support versioning.
 *
 * @remarks
 * Must be applied to a class that extends LitElement.
 */
function customElement(options) {
  return function customElementMixin(constructor) {
    return /*#__PURE__*/function (_constructor) {
      _inherits(_class, _constructor);
      var _super = _createSuper(_class);
      function _class() {
        _classCallCheck(this, _class);
        return _super.apply(this, arguments);
      }
      _createClass(_class, [{
        key: "createRenderRoot",
        value:
        /**
         * Invoked by LitElement to determine where the template should render
         *
         * @see
         * https://lit-element.polymer-project.org/guide/templates#renderroot
         */
        function createRenderRoot() {
          if (options.shadowDOM === undefined || options.shadowDOM) {
            // @ts-ignore typescript is unaware that `constructor` extends LitElement
            return _get(_getPrototypeOf(_class.prototype), "createRenderRoot", this).call(this);
          }
          return this;
        }
      }], [{
        key: "defineCustomElement",
        value:
        /**
         * Define the custom element within the CustomElementRegistry by combining
         * the value of `namespace` with the `componentName` property
         *
         * @param namespace - a string that will prefix the custom element's name (e.g., `${namespace}-component-name`)
         */
        function defineCustomElement() {
          var namespace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : options.namespace;
          this.namespace = namespace;
          var customElementName = "".concat(namespace, "-").concat(options.name);
          if (!customElements.get(customElementName)) {
            // @ts-ignore typescript is unaware that `constructor` extends HTMLElement
            customElements.define(customElementName, this);
          }
        }
      }]);
      return _class;
    }(constructor);
  };
}

export { customElement as default };
